// @flow
import type {BasicCfg, Cfg, ExtendedPortalCfg} from 'types';

import aiduAt from 'config/aidu-at';
import aiduCh from 'config/aidu-ch';
import aiduDe from 'config/aidu-de';
import common from 'config/common';
import reisegeierAt from 'config/reisegeier-at';
import reisegeierCh from 'config/reisegeier-ch';
import reisegeierDe from 'config/reisegeier-de';
import reisenDe from 'config/reisen-de';
import reisenFluegeDe from 'config/reisen-fluege-de';

const getPortalConfig = (portal: string): ExtendedPortalCfg => ({
  ...common,
  ...{
    'aidu-at': aiduAt,
    'aidu-ch': aiduCh,
    'aidu-de': aiduDe,
    'reisegeier-at': reisegeierAt,
    'reisegeier-ch': reisegeierCh,
    'reisegeier-de': reisegeierDe,
    'reisen-de': reisenDe,
    'reisen-fluege-de': reisenFluegeDe,
  }[portal],
});

const agentTLDMapping = {
  'aidu-de': 'de',
  'aidu-at': 'at',
  'aidu-ch': 'ch',
  'reisegeier-de': 'de',
  'reisegeier-at': 'at',
  'reisegeier-ch': 'ch',
  'reisen-de': 'de',
  'reisen-fluege-de': 'de',
};

const createConfig = (): Cfg => {
  const portalSettings: ExtendedPortalCfg = getPortalConfig(
    process.env.PORTAL_SHORT || 'aidu-de'
  );

  const loginUrl = process.env.LOGIN_URL || '';

  const settings: BasicCfg = {
    tld: agentTLDMapping[process.env.AGENT] || 'de',
    agent: process.env.AGENT || 'aidu-de',
    locale: process.env.LOCALE || 'de-DE',
    bookingServiceUrl: process.env.BOOKING_SERVICE || '',
    publicPath: process.env.PUBLIC_PATH || '',
    authUrl: process.env.AUTH_URL || '',
    portalName: process.env.PORTAL_NAME || '',
    portalUrl: process.env.PORTAL_URL || '',
    brandName: process.env.BRAND_NAME || '',
    portalOrigin: process.env.PORTAL_ORIGIN || '',
    portalDomain: process.env.PORTAL_DOMAIN || '',
    portalShort: process.env.PORTAL_SHORT || '',
    findBffUrl: process.env.FIND_BFF_URL || '',
    omnichannelOrgId: process.env.OMNICHANNEL_ORG_ID || '',
    omnichannelOrgUrl: process.env.OMNICHANNEL_ORG_URL || '',
    omnichannelWidgetId: process.env.OMNICHANNEL_WIDGET_ID || '',
    dataProtection: '/service/datenschutz',
    termOfUse: '/service/agb',
    loginUrl: loginUrl,
    signInUrl: loginUrl + '/auth/signin',
    passwordForgetUrl: loginUrl + '/auth/password-forget',
    linkMaskingKey: '',
    bdvPortalId: process.env.BDV_PORTAL_ID || '',
    reviewServiceUrl: process.env.REVIEW_SERVICE_URL || '',
    directusImageUrl: process.env.DIRECTUS_IMAGE_URL || '',
    splitApiSettings: {
      sdk: process.env.SPLIT_URL || '',
      events: process.env.SPLIT_URL || '',
      auth: process.env.SPLIT_URL || '',
    },
    splitApiKey: process.env.SPLIT_AUTH_KEY || '',
    usercentricsEnabled: process.env.USERCENTRICS_ENABLED === "true" || false,
    usercentricsSettingsId: process.env.USERCENTRICS_SETTINGS_ID || '',
    googleTagManagerContainerId: process.env.GTM_CONTAINER || '',
    googleTagManagerUrl: process.env.GTM_URL || '',
  };

  return {
    ...settings,
    ...portalSettings,
  };
};

export const config: Cfg = createConfig();
